import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appOnlyNumbers]'
})
export class OnlyNumbersDirective {
  private navigationKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const isNumber = /^\d$/.test(event.key);
    const isNavKey = this.navigationKeys.includes(event.key);

    if (!isNumber && !isNavKey) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const pasted = event.clipboardData?.getData('text') ?? '';
    if (!/^\d+$/.test(pasted)) {
      event.preventDefault();
    }
  }
}
